<template>
    <div class="myskov-login">
        <div class="myskov-login__col">
            <div class="login-fields">
                <h2 v-text="translations.title"></h2>
                <div class="input-fields">
                    <input-field :name="translations.input_email" :value="login.email" @input="(inp) => login.email = inp" @enter="onLogin" input-type="email" class="booking-field"></input-field>
                    <msg-block type="error" v-if="showErrors && isNotValid && isNotValid.email">
                        <p v-for="errorTxt in isNotValid.email"><b v-text="errorTxt"></b></p>
                    </msg-block>
                    <input-field :name="translations.input_password" :value="login.password" @input="(inp) => login.password = inp" @enter="onLogin" input-type="password" class="booking-field"></input-field>
                    <msg-block type="error" v-if="showErrors && isNotValid && isNotValid.password">
                        <p v-for="errorTxt in isNotValid.password"><b v-text="errorTxt"></b></p>
                    </msg-block>
                    <a href="javascript:void(0)" @click="$emit('forgetpw')" class="input-fields__text" v-text="translations.forget_pw_btn"></a>
                </div>
                <button class="btn" v-text="translations.login_btn" @click="onLogin" :disabled="loading" :class="{'item-loading': loading}"></button>
                <msg-block type="error" v-if="loginError">
                    <p><b v-text="loginError"></b></p>
                </msg-block>
            </div>
            <div class="new-user">
                <button class="btn btn--white" v-text="translations.create_account_btn" @click="$emit('newaccount')"></button>
            </div>
        </div>
        <div class="myskov-login__col">
            <div class="login-help">
                <h2 v-text="translations.help_txt_header"></h2>
                <ul class="profile-menu__list">
                    <li class="profile-menu__list__item" v-for="(text, txtKey) in translations.help_txt" v-html="text" :key="txtKey"></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import InputField from '../input-field.vue';
import MsgBlock from '../msg-block.vue';
import Validate from 'validate.js';

export default {
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.LOGIN,
            loading: false,
            showErrors: false,
            loginError: null,
            login: {
                email: "",
                password: ""
            }
        }
    },
    methods: {
        onLogin() {
            if(this.isNotValid) {
                this.showErrors = true;
                return;
            } else {
                this.showErrors = false;
            }

            if(this.loading)
                return;

            this.loginError = null;
            this.loading = true;
            this.$store.dispatch('login', this.login).then(() => {
                if(this.$route.query.navigateBack) {
                    this.$router.back();
                } else {
                    this.$router.push({
                        path: '/myskov/offers'
                    });
                }
            }).catch(() => {
                this.loginError = this.translations.ERRORS.login_error;
                this.loading = false;
            })
        }
    },
    computed: {
        isNotValid() {
            let errors = Validate(this.login, {
                email: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.email  
                    },
                    email: {
                        message: this.translations.ERRORS.not_valid_email
                    }
                },
                password: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.password
                    }
                }
            }, {
                fullMessages: false
            });

            return (errors) ? errors : null;
        }
    },
    components: {
        InputField,
        MsgBlock
    }
}
</script>

